export const SURROUND_AUDIO_SUFFIX = '-6CH';

export const CHROMECASTING_BANNER_SIZE = { width: 1000, height: 700 };

export const TEXT_TRACK_MINI_PLAYER = -3;
export const TEXT_TRACK_DEFAULT = 'auto';
export const TEXT_TRACK_MIDDLE = -4;

export const EXIT_FULL_WINDOW_AREA = {
  ICON: 'icon',
  TITLE: 'title',
};

export const AD_ROLL_TYPES = {
  preroll: 'preroll',
  midroll: 'midroll',
  postroll: 'postroll',
  intervalroll: 'intervalroll',
};

export const SUBTITLES_OFF = 'off';

export const CHROMECAST_STATUSES = {
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  BUFFERING: 'BUFFERING',
  PAUSED: 'PAUSED',
  PLAYING: 'PLAYING',
};
